import axios from './../http'

function query(data) {
    return axios.post('/sys/emailSendLog/query', data);
}

function get(id) {
    return axios.get('/sys/emailSendLog/get?id=' + id);
}

export default {
    query,
    get
}